import { AdminRoleUsersDirectory } from "@/features/admin/components/AdminRoleUsersDirectory";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/managers")({
    component: ManagersUsersPage,
});

function ManagersUsersPage() {
    return (
        <>
            <AdminRoleUsersDirectory role="MANAGER" emptyLabel="managers" />
            <Outlet />
        </>
    );
}
